angular
  .module('utility-ng-time')
  .constant('DateRangBuilderDTD', {
    start: 'moment',
    end: 'moment'
  })
  .factory('DateRangeBuilder', function (Interface, DateRangBuilderDTD) {
    return function DateRangeBuilder(data) {
      if (!(this instanceof DateRangeBuilder)) {
        return new DateRangeBuilder(data);
      }

      return Interface.implement(DateRangBuilderDTD, data, this);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-time/src/builders/date_range_builder.js